export default {"src":"/_next/static/media/fast-payments.48708696.svg","height":148,"width":282,"blurWidth":0,"blurHeight":0};